import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { Swiper, SwiperSlide } from 'swiper/react';
import axios from 'axios';
import APIEndPoints from '../middleware/APIEndPoints';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/effect-coverflow';
import 'swiper/css/pagination';

import { EffectCoverflow, Pagination } from 'swiper/modules';
import scrollTop from '../components/scrollTop';

import icon1 from "../assets/java.png";

import { fadeIn } from '../variants';

const Resume = () => {
  const [workingHistory, setWorkingHistory] = useState([]);
  const [educationHistory, setEducationHistory] = useState([]);
  const workingUrl = APIEndPoints.workinghistory.url;
  const educationUrl = APIEndPoints.educationhistory.url;

  useEffect(() => {
    scrollTop();
    fetchWorkingHistory();
    fetchEducationHistory();
  }, []);

  // Fetch working history records
  const fetchWorkingHistory = async () => {
    try {
      const response = await axios.get(workingUrl);
      setWorkingHistory(response.data);
    } catch (error) {
      console.error('Error fetching working history:', error);
    }
  };

  // Fetch education history records
  const fetchEducationHistory = async () => {
    try {
      const response = await axios.get(educationUrl);
      setEducationHistory(response.data);
    } catch (error) {
      console.error('Error fetching education history:', error);
    }
  };

 
  const testimonials = [
    { id: 1, name: 'Jack Garratt', role: 'Freelancer', text: 'Great designer! He finished our work wonderfully and just in time. Thanks for everything.', image: icon1 },
    { id: 2, name: 'April M. Griffin', role: 'Founder', text: 'Our logo and business card design look great. Thanks Henry!', image: icon1 },
    { id: 3, name: 'Jack Garratt', role: 'Freelancer', text: 'Great designer! He finished our work wonderfully and just in time. Thanks for everything.', image: icon1 },
    { id: 4, name: 'April M. Griffin', role: 'Founder', text: 'Our logo and business card design look great. Thanks Henry!', image: icon1 },
    { id: 5, name: 'Jack Garratt', role: 'Freelancer', text: 'Great designer! He finished our work wonderfully and just in time. Thanks for everything.', image: icon1 },
    { id: 6, name: 'April M. Griffin', role: 'Founder', text: 'Our logo and business card design look great. Thanks Henry!', image: icon1 },
    { id: 7, name: 'Jack Garratt', role: 'Freelancer', text: 'Great designer! He finished our work wonderfully and just in time. Thanks for everything.', image: icon1 },
    { id: 8, name: 'April M. Griffin', role: 'Founder', text: 'Our logo and business card design look great. Thanks Henry!', image: icon1 },
    { id: 9, name: 'Jack Garratt', role: 'Freelancer', text: 'Great designer! He finished our work wonderfully and just in time. Thanks for everything.', image: icon1 },
    { id: 10, name: 'April M. Griffin', role: 'Founder', text: 'Our logo and business card design look great. Thanks Henry!', image: icon1 },
    { id: 11, name: 'Larry M. Johnson', role: 'Freelancer', text: 'Henry is a very creative and talented designer. I do not hesitate to work again.', image: icon1 }
  ];



  return (
    <div className='mt-8 pt-8'>
      {/* Header Section with motion.div directly applying animation */}
      <motion.div
        initial={{ opacity: 0, y: -80 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1.2, ease: [0.25, 0.25, 0.25, 0.75] }}
        className='text-center mb-12 space-y-4'
      >
        <h4 className='text-3xl lg:text-[3rem] uppercase text-accent font-medium mb-2 tracking-wide'>Resume</h4>
        <h2 className='text-4xl lg:text-[4rem] font-bold mb-6'>My Professional Journey</h2>
        <p className='text-lg text-gray-400'>Explore my professional experience and academic background.</p>
      </motion.div>

      {/* Working and Education History Section */}
      <div className="flex flex-col lg:flex-row justify-between overflow-hidden ">
        <motion.div
          variants={fadeIn('right', 0.3)}
          initial="hidden"
          whileInView={"show"}
          viewport={{ once: false, amount: 0.3 }}
          className="w-full lg:w-1/2 p-4 bg-[#2e1e4e] shadow-inner shadow-yellow-300 rounded-lg overflow-y-auto max-h-[500px] ">
          <h3 className='text-2xl font-semibold mb-4 text-accent'>Working History</h3>
          <div className="relative border-l-4 border-gray-600 pl-6">
            {workingHistory.map((job) => (
              <motion.div
                key={job._id}
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                className='mb-6 relative hover:bg-black/40 cursor-pointer p-2 rounded-3xl'
              >
                <div className="absolute w-4 h-4 bg-accent rounded-full -left-2.5 top-0"></div>
                <h4 className='font-bold text-gray-300'>{job.title} - {job.company}</h4>
                <span className='text-sm text-gray-400'>{job.duration}</span>
                <p className='text-gray-300'>{job.description}</p>
              </motion.div>
            ))}
          </div>
        </motion.div>
        <motion.div
          variants={fadeIn('left', 0.5)}
          initial="hidden"
          whileInView={"show"}
          viewport={{ once: false, amount: 0.3 }}
          className="w-full lg:w-1/2 p-4 bg-[#2e1e4e] overflow-y-auto max-h-[500px] shadow-inner shadow-yellow-300 rounded-lg">
          <h3 className='text-2xl font-semibold mb-4 text-accent'>Education History</h3>
          <div className="relative border-l-4 border-gray-600 pl-6">
            {educationHistory.map((edu) => (
              <motion.div
                key={edu._id}
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                className='mb-6 relative hover:bg-black/40 cursor-pointer p-2 rounded-3xl'
              >
                <div className="absolute w-4 h-4 bg-accent rounded-full -left-2.5 top-0"></div>
                <h4 className='font-bold text-gray-300'>{edu.degree} - {edu.school}</h4>
                <span className='text-sm text-gray-400'>{edu.duration}</span>
                <p className='text-gray-300'>{edu.description}</p>
              </motion.div>
            ))}
          </div>
        </motion.div>
      </div>

      {/* Button Section */}
      <motion.div
        variants={fadeIn('up', 0.3)}
        initial='hidden'
        whileInView={'show'}
        viewport={{ once: false, amount: 0.7 }}
        className="flex flex-wrap justify-center gap-4 mt-8">
        <motion.button
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
          className="px-6 py-3 bg-blue-600 text-white rounded-full shadow-lg hover:bg-blue-700 transition duration-300 ease-in-out"
        >
          Download CV
        </motion.button>
        <motion.button
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
          className="px-6 py-3 bg-green-600 text-white rounded-full shadow-lg hover:bg-green-700 transition duration-300 ease-in-out"
        >
          Contact Me
        </motion.button>
        <motion.button
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
          className="px-6 py-3 bg-red-600 text-white rounded-full shadow-lg hover:bg-red-700 transition duration-300 ease-in-out"
        >
          My skills
        </motion.button>
        <motion.button
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
          className="px-6 py-3 bg-yellow-600 text-white rounded-full shadow-lg hover:bg-yellow-700 transition duration-300 ease-in-out"
        >
          My projects
        </motion.button>
      </motion.div>

      {/* Testimonials Section */}
      <motion.div
        variants={fadeIn('right', 0.3)}
        initial="hidden"
        whileInView={"show"}
        viewport={{ once: false, amount: 0.3 }}
        className="my-12 text-center">
        <h3 className='text-3xl font-semibold mb-6 text-accent'>Satisfied Clients</h3>
        <Swiper
          effect={'coverflow'}
          grabCursor={true}
          slidesPerView={2.5}
          centeredSlides={true}
          coverflowEffect={{
            rotate: 50,
            stretch: 0,
            depth: 100,
            modifier: 1,
            slideShadows: true,
          }}
          pagination={{ clickable: true }}
          modules={[EffectCoverflow, Pagination]}
          className="mySwiper"
        >
          {testimonials.map((testimonial) => (
            <SwiperSlide key={testimonial.id}>
              <motion.div
                whileHover={{ scale: 1.05 }}
                className='p-6 shadow-accent shadow-xl rounded-3xl sidebar text-white border-white border-2'
              >
                <img src={testimonial.image} alt={testimonial.name} className='mx-auto mb-4 rounded-full border-accent border-2 w-24 h-24 object-cover' />
                <h4 className='font-bold text-2xl'>{testimonial.name}</h4>
                <span className='text-sm text-gray-400'>{testimonial.role}</span>
                <p className='mt-2'>{testimonial.text}</p>
              </motion.div>
            </SwiperSlide>
          ))}
        </Swiper>
      </motion.div>
    </div>
  );
};

export default Resume;
